
document.addEventListener('DOMContentLoaded', function() {
  var label = document.getElementById('subscriptionDetailToggleLabel');
  var textBlock = document.getElementById('subscriptionDetailstextBlock');
  var arrowIcon = document.getElementById('subscriptionDetailarrowIconSvg');

  /*
  label.addEventListener('click', function() {
      // Toggle the display of the text block
      if (textBlock.style.display === 'none') {
          ShowSubscriptionDetails();
      } else {
          HideSubscriptionDetails();
      }
  });
  */


  AttachToSubscriptionOptions();
});

function ClearBindings()
{

  var myElement = document.getElementsByClassName('SubscriptionWidget')[0];


  var newElement = myElement.cloneNode(true);


  myElement.parentNode.replaceChild(newElement, myElement);


}

function ToggleSubscriptionDetails(lineId)
{
  return;
  
  console.log('ToggleSubscriptionDetails value =' + lineId);
  var textBlock = document.getElementById('subscriptionDetailstextBlock' + lineId);
  if (textBlock.style.display === 'none') {
      ShowSubscriptionDetails(lineId);
  } else {
      HideSubscriptionDetails(lineId);
  }
}

function ShowSubscriptionDetails(lineId)
{
  var textBlock = document.getElementById('subscriptionDetailstextBlock' + lineId);
  var arrowIcon = document.getElementById('subscriptionDetailarrowIconSvg' + lineId);
  textBlock.style.display = 'block';
  arrowIcon.classList.add('subscriptionDetailarrowrotate');
}
function HideSubscriptionDetails(lineId)
{
  var textBlock = document.getElementById('subscriptionDetailstextBlock' + lineId);
  var arrowIcon = document.getElementById('subscriptionDetailarrowIconSvg' + lineId);
  textBlock.style.display = 'none';
  arrowIcon.classList.remove('subscriptionDetailarrowrotate');
}

function AttachToSubscriptionOptions()
{
  const radiosSubscriptionOption = document.querySelectorAll('.cart__items .subscriptionOption');

  radiosSubscriptionOption.forEach(radio => {
      radio.addEventListener('change', function() {
          console.log('Selected value:', this.value);

      });
  });

  const sellingPlanOptions = document.querySelectorAll('.cart__items .rc-selling-plans-dropdown__select');

  sellingPlanOptions.forEach(planOption => {
    planOption.addEventListener('change', function() {
      console.log('Selected value:', this.value);

      var selectedOption = this.options[this.selectedIndex];
      var selectedOptionValue = selectedOption.getAttribute("sellingplandata");

      console.log('selectedOptionValue = ' + selectedOptionValue );

      var splitValue = selectedOptionValue.split('|');
      var planId = splitValue[0];
      var lineId = splitValue[1];
      var quantity = splitValue[2];
      console.log('planId:' + planId + " lineId:" + lineId + " quantity:" + quantity);
      updateSellingPlan(lineId, planId, quantity);
    });
  });
}

function RemoveSubscriptionOptionCart(lineId, newQuantity)
{
  updateSellingPlan(lineId, null, newQuantity);
}


function InitializeSubscriptionOptionCart(lineId, planId, newQuantity)
{
  var targetId = "SubscriptionOptions" + lineId;
  updateSellingPlan(lineId, planId, newQuantity);
}


function UpdateSubscriptionOption(subOption)
{
  var selectedOption = subOption.options[subOption.selectedIndex];
  var selectedOptionValue = selectedOption.getAttribute("sellingplandata");

  console.log('selectedOptionValue = ' + selectedOptionValue );

  var splitValue = selectedOptionValue.split('|');
  var planId = splitValue[0];
  var lineId = splitValue[1];
  var quantity = splitValue[2];
  console.log('planId:' + planId + " lineId:" + lineId + " quantity:" + quantity);
  updateSellingPlan(lineId, planId, quantity);
}

var updateSellingPlanProcessing = false;
function updateSellingPlan(lineId, newSellingPlanId, newQuantity) {


  if(updateSellingPlanProcessing)
  {
    console.log('Currently Processing Update, duplicate request logged');
    return;
  }
  
  updateSellingPlanProcessing = true;
  console.log('lineId = ' + lineId + ' | newSellingPlanId = ' + newSellingPlanId + ' | newQuantity = ' + newQuantity);

    var data = {
        line: parseInt(lineId),
        quantity: parseInt(newQuantity),
        selling_plan: newSellingPlanId
    };

    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function(response) {
          console.log('Cart updated successfully', response);
          RefreshCartData();
          updateSellingPlanProcessing = false;
        },
        error: function(xhr, status, error) {
          // Handle errors here
          console.error('Error updating cart', status, error);
        }
    });
}


function CartOpenDeliveryOptions(idToOpen)
{
  console.log("CartOpenDeliveryOptions");
  var dropdown = document.getElementById(idToOpen);
  dropdown.showPicker();
}


